import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);
dayjs.locale('ru');

/**
 * Форматирует ISO-дату как `21 мая 2026, 14:32`.
 *
 * Используется в таблицах для колонок «Создан» / «Последний вход».
 */
export function formatDateTime(iso: string | undefined | null): string {
  if (!iso) return '';
  const d = dayjs(iso);
  return d.isValid() ? d.format('D MMM YYYY, HH:mm') : '';
}

/**
 * Форматирует дату без времени как `21 мая 2026` — для полей типа
 * «срок платежа», где времени в данных нет.
 */
export function formatDate(iso: string | undefined | null): string {
  if (!iso) return '';
  const d = dayjs(iso);
  return d.isValid() ? d.format('D MMM YYYY') : '';
}

/**
 * Возвращает относительное представление даты (`2 часа назад`, `вчера`).
 */
export function formatRelative(iso: string | undefined | null): string {
  if (!iso) return '';
  const d = dayjs(iso);
  return d.isValid() ? d.fromNow() : '';
}
